import { find } from '@dt/fe-utils/dist/lodash'
import React, { FC, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { format } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import { Icon, UseHeader } from '@cps'
import { IonButton, IonContent, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonList, IonPage } from '@ionic/react'
import { bankCardMobx } from '@mobxStore'
import './bankCardManage.scss'

const CardItem: FC<{ maskedPan: string }> = ({ maskedPan }) => {
  const sliding = useRef(null)
  const lastUsedCard = find(bankCardMobx.memberBankCards, x => x.lastUsed)

  const trash = async (e: any) => {
    e.stopPropagation()
    if (sliding.current) {
      await sliding.current.closeOpened()
      await sliding.current.open()
    }
  }

  const del = () => {
    bankCardMobx.removeMaskedPan(maskedPan)
  }

  return (
    <IonItemSliding ref={sliding} disabled>
      <IonItem>
        <div className='card-number'>
          {format.maskCardNumber(maskedPan)}
          {lastUsedCard && (lastUsedCard.creditCardNumber || '').endsWith(maskedPan) && (
            <div className='recently-used'>{i18n.t('pay.recentlyUsed')}</div>
          )}
        </div>
        <Icon slot='end' name='trash' onClick={trash} />
      </IonItem>
      <IonItemOptions side='end'>
        <IonItemOption>
          <IonButton className='delete-button' onClick={del}>{i18n.t('pay.confirmDelete')}</IonButton>
        </IonItemOption>
      </IonItemOptions>
    </IonItemSliding>
  )
}

const BankCardManage = () => {
  const history = useHistoryNew()
  const list = useRef(null)

  useEffect(() => {
    bankCardMobx.loadMaskedPan()
  }, [])

  const onClick = () => {
    if (list.current) {
      list.current.closeSlidingItems()
    }
  }

  return (
    <IonPage className='bank-card-manage'>
      <UseHeader title={i18n.t('pay.bankCardManage')} onBack={() => history.goBack()}></UseHeader>
      <IonContent onClick={onClick}>
        {bankCardMobx.maskedPanList && bankCardMobx.maskedPanList.length > 0 ? (
          <IonList ref={list} inset lines='none'>
            {bankCardMobx.maskedPanList.map(x => (
              <CardItem key={x} maskedPan={x} />
            ))}
          </IonList>
        ) : (
          <div className='no-bank-card'>{i18n.t('pay.noBankCard')}</div>
        )}
      </IonContent>
    </IonPage>
  )
}

export default observer(BankCardManage)
